import { Capacitor } from '@capacitor/core';

export default {
    name: 'newAccountBanner',
    props: {
        size: {
            type: String,
            default: 'big',
            required: true
        }
    },

    data() {
        return {
            intervener: {}
        };
    },

    async mounted() {
        this.intervener = await this.$store.getters.getIntervener;
    },

    methods: {
        navigateToWeb(url, method) {
            try {
                if (!Capacitor.isNativePlatform()) {
                    window.open(url);
                    return;
                }

                this.ref = window.cordova.InAppBrowser.open(
                    url,
                    method,
                    'location=no,beforeload=yes,'
                );

                this.ref.addEventListener('beforeload', (params, callback) => {
                    callback(params.url);
                });
            } catch (err) {
                window.open(url);
                return;
            }
        },

        redirectToOb() {
            const codedDocumentId = window.btoa(this.intervener.document_id);
            this.navigateToWeb(
                `${process.env.VUE_APP_ONBOARDING_HOST}paso10?login=true&id=${codedDocumentId}`,
                '_blank'
            );
        }
    }
};
